// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'

const rhdhvLight = {
    dark: false,
    colors: {
        background: '#FFFFFF',
        surface: '#FFFFFF',
        primary: '#009EAB',
        secondary: '#009EAB',
        highlight: '#CCECEE',
        speckleColor: '#047EFB'
    }
}

export default createVuetify(
    {
        blueprint: md3,
        theme: {
            defaultTheme: 'rhdhvLight',
            themes: {
                rhdhvLight
            }
        },
        defaults: {
            VTextField: {
                variant: 'filled'
            },
            VSelect: {
                variant: 'filled'
            },
            VTextarea: {
                variant: 'filled'
            }
        }
    }

    // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
)
